/** Trigger a browser download for a Blob using the given filename. */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

/** Extract a filename from a Content-Disposition header, falling back if absent. */
export const filenameFromDisposition = (disposition, fallback) => {
  if (!disposition) return fallback;
  const match = /filename\*?=(?:UTF-8'')?"?([^";\n]+)"?/i.exec(disposition);
  return match ? decodeURIComponent(match[1].trim()) : fallback;
};
